// extracted by mini-css-extract-plugin
module.exports = {"privacyPageContent":"privacy_privacyPageContent__4909I"};